var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.614,
    height: 101.273,
    viewBox: "0 0 88.614 101.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user",
    d: "M62.03,60.131c-5.677,0-8.406,3.165-17.723,3.165s-12.026-3.165-17.723-3.165A26.591,26.591,0,0,0,0,86.715v5.064a9.5,9.5,0,0,0,9.494,9.494H79.12a9.5,9.5,0,0,0,9.494-9.494V86.715A26.591,26.591,0,0,0,62.03,60.131ZM79.12,91.779H9.494V86.715a17.12,17.12,0,0,1,17.09-17.09c2.888,0,7.576,3.165,17.723,3.165,10.226,0,14.815-3.165,17.723-3.165a17.12,17.12,0,0,1,17.09,17.09ZM44.307,56.966A28.483,28.483,0,1,0,15.824,28.483,28.491,28.491,0,0,0,44.307,56.966Zm0-47.472A18.989,18.989,0,1,1,25.318,28.483,19.019,19.019,0,0,1,44.307,9.494Z",
    fill: "#727272"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.058f9d07.svg";
export { ForwardRef as ReactComponent };